const config = {
  development: {
    // Use empty string or '/api' in development to use Vite proxy
    API_BASE_URL: import.meta.env.VITE_BACKEND_URL || '',
    ADMIN_API_BASE_URL: import.meta.env.VITE_ADMIN_API_BASE_URL || '/api/admin',
    APP_NAME: import.meta.env.APP_NAME || 'AdSaga Admin Panel',
    VERSION: import.meta.env.APP_VERSION || '1.0.0',
    DEBUG_MODE: import.meta.env.DEBUG_MODE === 'true' || false,
    LOG_LEVEL: import.meta.env.LOG_LEVEL || 'debug',
    COMPANY_NAME: import.meta.env.COMPANY_NAME || 'AdSaga',
    COMPANY_LOGO_URL: import.meta.env.COMPANY_LOGO_URL || '/assets/adsaga_logo.svg',
    PRIMARY_COLOR: import.meta.env.PRIMARY_COLOR || '#8B5CF6',
    SECONDARY_COLOR: import.meta.env.SECONDARY_COLOR || '#3B82F6',
    ENABLE_ANALYTICS: import.meta.env.ENABLE_ANALYTICS === 'true' || false,
    ENABLE_DARK_MODE: import.meta.env.ENABLE_DARK_MODE === 'true' || true,
    ENABLE_NOTIFICATIONS: import.meta.env.ENABLE_NOTIFICATIONS === 'true' || true
  },
  production: {
    API_BASE_URL: import.meta.env.VITE_BACKEND_URL || '',
    ADMIN_API_BASE_URL: import.meta.env.VITE_ADMIN_API_BASE_URL || '',
    APP_NAME: import.meta.env.APP_NAME || 'AdSaga Admin Panel',
    VERSION: import.meta.env.APP_VERSION || '1.0.0',
    DEBUG_MODE: import.meta.env.DEBUG_MODE === 'true' || false,
    LOG_LEVEL: import.meta.env.LOG_LEVEL || 'error',
    COMPANY_NAME: import.meta.env.COMPANY_NAME || 'AdSaga',
    COMPANY_LOGO_URL: import.meta.env.COMPANY_LOGO_URL || '/assets/adsaga_logo.svg',
    PRIMARY_COLOR: import.meta.env.PRIMARY_COLOR || '#8B5CF6',
    SECONDARY_COLOR: import.meta.env.SECONDARY_COLOR || '#3B82F6',
    ENABLE_ANALYTICS: import.meta.env.ENABLE_ANALYTICS === 'true' || true,
    ENABLE_DARK_MODE: import.meta.env.ENABLE_DARK_MODE === 'true' || true,
    ENABLE_NOTIFICATIONS: import.meta.env.ENABLE_NOTIFICATIONS === 'true' || true
  }
}

const environment = import.meta.env.MODE || 'development'

export default config[environment]
